module.exports = __webpack_public_path__ + "img/union.9b59a572.svg";